import OptionChainUseCase from "@domains/features/Markets/Options/useCases/OptionChain";
import fnoBanUseCase from "@domains/features/Markets/Options/useCases/FnoBan";
import NewOnEdelUseCase from "@domains/features/Markets/Common/useCases/NewOnEdelUseCase";
import { commonQuotesHomePageRepository } from "../../../../../../../mainDi/webDi";
import UnderstandingSectionUseCase from "@domains/features/Markets/Common/useCases/UnderstandingSectionUseCase";
import ExpiryDateUseCase from "@domains/features/Markets/Options/useCases/ExpiryDateUseCase";
import OpRecommendationsUseCase from "@domains/features/Markets/Options/useCases/OpRecommendationUseCase";
import HighestOI from "@domains/features/Markets/Options/useCases/iHighestOI";
import HighestOIGainer from "@domains/features/Markets/Options/useCases/iHighestOIGainers";
import HighestLoser from "@domains/features/Markets/Options/useCases/iHighestOILosers";
import HighestVolume from "@domains/features/Markets/Options/useCases/iHighestVolume";
import StreamUseCase from "@domains/useCases/StreamUsecase";
import BseNseExpiryDateUseCase from "@domains/features/Markets/Options/useCases/BseNseExpiryDateUseCase";
export default (function (repositories) {
    return {
        optionMarket: {
            optionChain: new OptionChainUseCase(repositories.option),
            newOnEdelUseCase: new NewOnEdelUseCase(commonQuotesHomePageRepository),
            understandingSection: new UnderstandingSectionUseCase(repositories.common),
            expiryDateUseCase: new ExpiryDateUseCase(repositories.option),
            fnoBanUseCase: new fnoBanUseCase(repositories.option),
            OpRecommendationsUseCase: new OpRecommendationsUseCase(repositories.option),
            qouteStreaming: new StreamUseCase(repositories.qouteStream),
            nseBseExpiry: new BseNseExpiryDateUseCase(repositories.option),
        },
        optionsDriveMarket: {
            highestOIGainer: new HighestOIGainer(repositories.option),
            highestOILosers: new HighestLoser(repositories.option),
            highestOI: new HighestOI(repositories.option),
            highestVolumeGroth: new HighestVolume(repositories.option),
        },
    };
});
